import {useContext} from 'react'
import {SpeakingContext} from './SpeakingContext'

export function useIsParticipantSpeaking(identity: string): boolean {
  const speakingMap = useContext(SpeakingContext)
  return speakingMap.get(identity) ?? false
}
